/* global __webpack_modules__ */

import mori from 'mori';
import { getDataRankings } from './';
import filtersModule from '../../filters/filters';
import { appDefault } from '../../config/config';
import slugify from '../../util/slugify';
import switchFilter from '../../filters/switchFilter';
let filterSwitch = null;

if (__webpack_modules__[require.resolveWeak('angular')]) {
  filterSwitch = angular
    .injector(['ng', filtersModule])
    .get('filterSwitchFilter');
} else {
  //  This is react's territory
  filterSwitch = switchFilter();
}

const cellRendererVars = {
  rankings: {},
};

export default function({
  api,
  // data,
  value,
  column,
  rowIndex,
  linkTarget,
  linkColumn,
  linkContext,
  currentHeader,
  selectedHeaders,
  geoMulti, // eslint-disable-line no-unused-vars
  baseContext,
}) {
  const { text, data, child, group } = value;
  const { characteristic } = currentHeader;
  const context = (data.Location && 'Location') || baseContext || 'State';

  let footnotes = [];
  if (api.footnoteCallback) {
    const key = [
      data[context],
      (child !== false) ? ([group, child]) : group,
    ];

    if (data[context] && data[context] !== text) {
      key.push(`${text}`);
    }
    footnotes = api.footnoteCallback(key);
  }

  const notes = footnotes
    .sort(({ label: a }, { label: b }) => a - b)
    .map(footnoteMark)
    .join(', ');

  const formattedValue = filterSwitch(
    text, currentHeader
  );
  const cellAnchor = linkTarget &&
    linkColumn &&
    linkColumn === characteristic ?
    getLinkTargetUrl(linkTarget, linkContext, formattedValue) : null;

  // Only rank geos w/ sorting on different column
  // If column.sort is null it means it's sorted on different column
  let rank = '';
  if (currentHeader.idx === 0 && column.sort === null) {
    let colIdx = 0;
    let sortDir;
    let headerName;
    const rowsToDisplay = api.rowModel.rowsToDisplay.length;
    const isWrapup = appDefault.specialWrapups.indexOf(text) >= 0;
    const currentSortColumn = api.columnController
      .allDisplayedColumns
      .reduce((acc, curr, index) => curr.sort && !acc ?
        (colIdx = index) &&
        (headerName = curr.colDef.headerName) &&
        (sortDir = curr.sort) && curr.colId :
        acc,
        false
      );
    if (!currentSortColumn) {
      rank = '';
    } else {
      const dataValue =
        api.rowModel.rowsToDisplay[rowIndex].data[currentSortColumn];

      const isNaData = appDefault.dataNotAvailable.indexOf(
        dataValue !== null ? dataValue : ''
      ) >= 0;
      const sortKey = `${currentSortColumn}-${sortDir}`;

      // Catches for Linechart data maps
      if (mori.count(selectedHeaders) - 1 < colIdx) {
        colIdx = (colIdx % (mori.count(selectedHeaders) - 1)) + 1;
      }

      // Check if rankings for this sort exist, and store the length.
      // If the # of rows to render has changed (not equal to rankings)
      // we need to re-rank, as we cannot tell exactly what changed.
      const rankingsExist = !!cellRendererVars.rankings[sortKey];
      const rankingsLength =
        rankingsExist ? cellRendererVars.rankings[sortKey].length : 0;
      cellRendererVars.rankings[sortKey] =
        (rankingsExist && rankingsLength === rowsToDisplay) ?
          cellRendererVars.rankings[sortKey] :
          getDataRankings(
            api,
            currentSortColumn,
            mori.toJs(
              // Getting the nth selectedHeader is not reliable if we are
              // on the trend graph view.  We want to get the header
              // based on what the current sort column is - using headerName.
              mori.first(
                mori.filter(
                  (item) => item.characteristic === headerName,
                  selectedHeaders
                )
              )
            )
          );

      rank = isWrapup || isNaData ? '' :
        `${cellRendererVars.rankings[sortKey][rowIndex]}. `;
    }
  }

  // Remove HTML tags from title for span
  const strippedTitle = typeof formattedValue === 'string' ?
    formattedValue.replace(/<[^>]+>/g, '') :
    formattedValue;

  return (`<span title="${strippedTitle}">
      ${rank}${cellAnchor ? cellAnchor : ''}
      ${formattedValue} <sup>${notes}</sup>
      ${cellAnchor ? '</a>' : ''}
    </span>`
  );
}

function getLinkTargetUrl(url, linkContext, value) {
  const tree = encodeURIComponent(
    JSON.stringify({
      [slugify(linkContext)]: {
        [slugify(value)]: {},
      },
    })
  );

  return `<a href="${url}?selectedRows=${tree}" target="_self">`;
}

function footnoteMark({ id, label }) {
  return `<a href="#note-${id}">${label}</a>`;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/cellRenderer.js
 **/